// TODO: constrain to full list of cases.

import {
    DjangoFontPosture,
    DjangoFontWeight,
    DjangoFontWidth,
    FontPosture,
    FontWeight,
    FontWidth,
} from '../../constants';
import { hasOwnProperty } from '../../functions/hasOwnProperty';
import { IDjangoFontModel } from './FontModel';
import { FontVisibility } from './FontVisibility';
import { CharacterSet } from './StyleCharset';
import { IVFInfo, IVFInstance } from './VariableFonts';

enum CodePage {
    ASCII = 'English',
    ISO_8859_15 = 'Western European',
    ISO_8859_2 = 'Central European',
    ISO_8859_10 = 'Northern European',
    WINDOWS_1251 = 'Cyrillic',
    ISO_8859_9 = 'Turkish',
    WINDOWS_1253 = 'Greek',
    WINDOWS_1255 = 'Hebrew',
    WINDOWS_1256 = 'Arabic',
    WINDOWS_1258 = 'Vietnamese',
    WINDOWS_874 = 'Thai',
    WINDOWS_932 = 'Japanese',
    WINDOWS_936 = 'Simplified Chinese',
    WINDOWS_950 = 'Traditional Chinese',
    WINDOWS_949 = 'Korean',
}

export const CODE_PAGE_KEYS = [
    'Western European',
    'Central European',
    'Cyrillic',
    'Greek',
    'Hebrew',
    'Northern European',
    'Turkish',
    'Arabic',
    'Vietnamese',
    'Thai',
    'Japanese',
    'Simplified Chinese',
    'Traditional Chinese',
    'Korean',
] as const;
export type CodePageKey = (typeof CODE_PAGE_KEYS)[number];

// ex) 'uppercase' | 'lowercase'
export type Case = string;
export type CaseSupport = {
    uppercase: number;
    lowercase: number;
    caseless: number;
};
export type CodePageCaseSupport = Record<CodePage, CaseSupport>;
//{
//     // TODO: get full list of allows codepage values
//     // ex) 'Arabic'| 'Central European' | 'Cyrillic' | 'Greek' | 'Hebrew' | 'Northern European' | 'Turkish' | 'Western European'  |
//     [codepage: CodePage]: CaseSupport; // cases ,
// };
export type LanguageSupport = Record<CodePage, CaseSupport>;
// {
//     [codepage: string]: Languages;
// };

// TODO: constrain to the full list of available languages.
// ex) "ENG" | "AFK" | "SQI" | "EUQ" | "BRE" | "DAN" | "FOS" | "FIN" | "FRA" | "GAE" | "GAL" | "DEU" | "ISL" | "IRI" | "ITA" | "KUR" | "LAT" | "LTZ" | "NOR" | "OCI" | "RMS" | "ESP" | "SWK" | "SVE" | "BEL" | "BOS" | "HRV" | "CSY" | "HUN" | "LSB" | "PLK" | "SRB" | "SKY" | "SLV" | "USB | "ETI" | "GRN" | "LVI" | "LTH"
export type Language = string;
export type Languages = Language[];

// TODO: constrain to the full list of opentype features
// ex) "case" | "ordn" | "frac" | "liga" | "numr" | "sups" | "zero" | "aalt" | "dnom" | "subs" | "sinf" | "pnum" | "tnum" | "salt" | "ss01"
export type OTFeature = string;
export type OTFeatures = OTFeature[];

export type Subset = {
    [name: string]: {
        display_name: string;
        hidden: boolean;
        // unicode or unicode ranges
        character_range: string[];
    };
};

export interface IStylesSrefParams {
    familyName: string;
    foundryEESubdomain?: string;
    styleName: string;
}

export interface IDjangoFontStyleMinimal {
    id: number;
    name: string;
    style_name: string;
    family_name: string;
    family: number;
    foundry: number[];
    base_price: string;
    available_subsets: Subset[];
    bucket: number;
}

export interface IDjangoFontStyle extends IDjangoFontModel {
    allow_desktop_trials: boolean;
    available_subsets: Subset[];
    axis?: IVFInstance;
    base_price: string;
    category: number[];
    // indicates if this is the default style for a family.
    default_style: boolean;
    ee_subdomain: string;
    family: number;
    family_name: string;
    family_slug: string;
    family_visible: FontVisibility;
    font_file_id: number;
    grade: number;
    isRE: boolean;
    max_recommended_size: number;
    min_recommended_size: number;
    mood: number[];
    optical: number;
    parametric_width: number;
    parametric_weight: number;
    posture: DjangoFontPosture;
    style_name: string;
    support: {
        codepageSupport: CodePageCaseSupport;
        languageSupport: LanguageSupport;
        otFeatures: OTFeatures;
    };
    tn_width: number;
    tn_weight: number;
    specimen_text: string;
    variable_info: IVFInfo;
    weight: DjangoFontWeight;
    width: DjangoFontWidth;
}

export interface IFontStyleModel
    extends Omit<IDjangoFontStyle, 'posture' | 'width' | 'weight'> {
    // properties in the front end only.
    getSrefParams: () => IStylesSrefParams;
    label: string;
    posture: FontPosture;
    weight: FontWeight;
    width: FontWidth;

    // latinized version of the name to play nice with the latin subset.
    latin_name: string;

    /**
     * @deprecated - this is glommed on by tnGlyphs and only used on those pages. We should not add it directly to this class, but have a
     * view/component specific carrier instead.
     */
    character_set?: CharacterSet;

    /**
     * @deprecated do not use, added to make FilteredModels typings play nice.
     * TODO: reimplement filtering so it's a little more concrete based on what is being
     * filtered.
     */
    language?: string;
}

export function isIFontStyle(obj: unknown): obj is IFontStyleModel {
    return hasOwnProperty(obj, 'family') && hasOwnProperty(obj, 'style_name');
}
